import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { laedgroupForm } from '../../leads/model/lead.model';

@Component({
  selector: 'app-lead-group',
  templateUrl: './lead-group.component.html',
  styleUrls: ['./lead-group.component.css']
})
export class LeadGroupComponent implements OnInit {
    
    form :FormGroup
  submitted: boolean=false;
  edit:any=0
  cdata: any;
  get f() { return this.form.controls; }
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<LeadGroupComponent>,protected fb: FormBuilder) {
    this.edit = this.data.edit
    if(this.edit){
      this.cdata = new laedgroupForm(this.data.data);
       this.form = this.cdata.makeform(this.fb);
    }
    else{
      this.cdata = new laedgroupForm(null);
       this.form = this.cdata.makeform(this.fb);
    }
  }

  ngOnInit() {

    
  }
  onSubmitgroup(){
      this.submitted=true
      if(!this.form.valid){
        return
      }

    this.dialogRef.close(this.form.value);
    
  }

  blockSpaces(event: KeyboardEvent) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.trim() === '' && event.key === ' ') {
      event.preventDefault();
    }
  }
  close(){
    this.dialogRef.close();
  }
}
